import React from 'react';
import { Table } from '@common/components';
import { formatLength } from '@scheduling/components';
import { formatTimeZone } from '@common/services/datetime';
import { OrganizationUnitShiftConfig } from '@scheduling/graphql';

type Props = {
  shiftTimes?: OrganizationUnitShiftConfig[];
  loading: boolean;
  emptyText?: string;
};

export function CopyShiftTimesShiftsTable({
  shiftTimes,
  loading,
  emptyText,
}: Props) {
  const columns = [
    {
      title: 'Role',
      key: 'role',
      render: (record: OrganizationUnitShiftConfig) =>
        record.role?.abbreviation || 'Default',
      width: '15%',
    },
    {
      title: 'Groups',
      key: 'groups',
      render: (record: OrganizationUnitShiftConfig) =>
        record.workforceGroups?.map((group) => group.name).join(', ') || 'All',
      width: '25%',
    },
    {
      title: 'Display Time',
      key: 'displayTime',
      render: (_: string, record: OrganizationUnitShiftConfig) => {
        return `${formatTimeZone(record.startTime)} - ${formatTimeZone(
          record.endTime
        )}`;
      },
      width: '20%',
    },
    {
      title: 'Workload Settings',
      key: 'workloadSettings',
      render: (_: string, record: OrganizationUnitShiftConfig) => {
        if (!record.workloadStartTime || !record.workloadEndTime) {
          return '-';
        }

        return `${formatTimeZone(record.workloadStartTime)} - ${formatTimeZone(
          record.workloadEndTime
        )}`;
      },
      width: '20%',
    },
    {
      key: 'length',
      dataIndex: 'length',
      title: 'Length',
      render: (_: string, record: OrganizationUnitShiftConfig) =>
        formatLength(record),
      width: '15%',
    },
  ];

  return (
    <Table
      dataSource={
        shiftTimes?.map((unit) => {
          return {
            ...unit,
            key: unit.id,
          };
        }) || []
      }
      columns={columns}
      loading={loading}
      locale={{
        emptyText: emptyText,
      }}
    />
  );
}
